import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

Highcharts.setOptions({
    time: {
        useUTC: false,
    },
});

const Chart = (props) => (
    <HighchartsReact highcharts={Highcharts} {...props} />
);

export default Chart;
